<section class="goodbase-batch" role="dialog" aria-modal="false" aria-labelledby="goodbase-batch-title" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <header>
        <h2 id="goodbase-batch-title">Добавление товаров</h2>
        <button ui-kit icon="cross" color="ghost-neutral" size="small" type="button" aria-label="Закрыть" [disabled]="saving" (click)="cancel()"></button>
    </header>
    <p class="hint">Проверьте товары перед сохранением. Удалённые строки останутся в таблице и не будут добавлены.</p>
    <div *ngIf="error" class="error" role="alert">{{error}}</div>
    <div class="table-scroll">
        <table>
            <thead><tr><th class="number">№</th><th>Наименование *</th><th>Категория *</th><th>ЕИ *</th><th class="action"></th></tr></thead>
            <tbody>
                <tr *ngFor="let row of rows; let i = index; trackBy: trackRow" [class.deleted]="row.deleted" [attr.data-row-id]="row.rowId" [attr.data-deleted]="row.deleted">
                    <td class="number">{{i + 1}}</td>
                    <td data-field="name">
                        <table-field ui-kit [fieldController]="row.name" [attr.aria-label]="'Наименование товара ' + (i + 1)"></table-field>
                        <span class="field-error" *ngIf="fieldError(row, 'name')">{{fieldError(row, 'name')}}</span>
                        <span class="saved" *ngIf="row.savedId">Сохранён</span>
                        <span class="field-error" *ngIf="row.saveError && !row.deleted">{{row.saveError}}</span>
                    </td>
                    <td data-field="categoryId">
                        <table-field ui-kit [fieldController]="row.category" [showConfig]="row.category.showConfig" [attr.aria-label]="'Категория товара ' + (i + 1)"></table-field>
                        <span class="field-error" *ngIf="fieldError(row, 'categoryId')">{{fieldError(row, 'categoryId')}}</span>
                    </td>
                    <td data-field="unitId">
                        <table-field ui-kit [fieldController]="row.unit" [showConfig]="row.unit.showConfig" [attr.aria-label]="'ЕИ товара ' + (i + 1)"></table-field>
                        <span class="field-error" *ngIf="fieldError(row, 'unitId')">{{fieldError(row, 'unitId')}}</span>
                    </td>
                    <td class="action" data-field="deleted">
                        <button ui-kit type="button" color="ghost-neutral" size="small" [disabled]="saving || !!row.savedId" (click)="toggleDeleted(row)"
                                [attr.aria-label]="(row.deleted ? 'Восстановить' : 'Удалить') + ' строку ' + (i + 1)">{{row.deleted ? '↶' : '×'}}</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <button ui-kit type="button" color="secondary-neutral" size="small" [disabled]="saving || rows.length >= maxRows" (click)="addRow()">+ Добавить строку</button>
    <div class="goodbase-batch-footer">
        <span class="count">К добавлению: {{activeCount()}}<span *ngIf="savedCount()"> · Сохранено: {{savedCount()}}</span></span>
        <button ui-kit type="button" color="secondary-neutral" size="medium" [disabled]="saving" (click)="cancel()">Отмена</button>
        <button ui-kit type="button" color="primary-accent" size="medium" [disabled]="saving || !activeCount()" [loading]="saving" (click)="save()">{{saving ? 'Сохранение…' : 'Сохранить'}}</button>
    </div>
</section>
